import { render, staticRenderFns } from "./EventUserFeedback.vue?vue&type=template&id=6e2aefc2&scoped=true"
import script from "./EventUserFeedback.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventUserFeedback.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventUserFeedback.vue?vue&type=style&index=0&id=6e2aefc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2aefc2",
  null
  
)

export default component.exports